'use client'
import { Table, TableRow, TableHeader, TableCell, SmartLink, Pagination, MoreButton } from "@/components/ui";
import { SquareCheck, Trash, SquareX, Pen } from "@/assets/icons";
import { PaginationParams, VisitorsResponse } from "@/types";
import React, { useEffect, useState } from "react";
import { listVisitors } from "@/app/api";

export function VisitorsTable() {
    const [showObservation, setShowObservation] = useState<Record<string, boolean>>({})
    const [visitorsData, setVisitorsData] = useState<VisitorsResponse>()
    const [filters, setFilters] = useState<PaginationParams>({
        page: 1,
        perPage: 10,
    });

    useEffect(() => {
        const fetchVisitors = async () => {
            try {
                const data = await listVisitors(filters)
                setVisitorsData(data)
            } catch (err) {
                console.log("Erro ao carregar visitantes: ", err);
            }
        }

        fetchVisitors()
    }, [filters])

    const toggleExpand = (visitorId: string) => {
        setShowObservation(prev => ({
            ...prev,
            [visitorId]: !prev[visitorId]
        }))
    }

    const handlePageChange = (page: number) => {
        setFilters({ ...filters, page });
    };

    const visitors = visitorsData?.data || []

    return (
        <div className="p-8">
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>Enviar notificações</TableHeader>
                            <TableHeader colSpan={2}>Data de entrada</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        {visitors.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={6} className="text-center">
                                    Ainda não existem visitantes do site.
                                </TableCell>
                            </TableRow>
                        ) : (visitors.map((visitor) => (
                            <React.Fragment key={visitor.id}>
                                <TableRow>
                                    <TableCell>{visitor.sequence}</TableCell>
                                    <TableCell>{visitor.name}</TableCell>
                                    <TableCell>{visitor.email || 'Não informado'}</TableCell>
                                    <TableCell className="flex items-center">
                                        {visitor.receiveNotifications
                                            ? <SquareCheck />
                                            : <SquareX />}
                                    </TableCell>
                                    <TableCell>{new Date(visitor.createdAt).toLocaleDateString()}</TableCell>
                                    <TableCell>
                                        <MoreButton onClick={() => toggleExpand(visitor.id)} />
                                    </TableCell>

                                </TableRow>
                                {showObservation[visitor.id] && (
                                    <TableRow>
                                        <TableHeader>Observação</TableHeader>
                                        <TableCell colSpan={4}>{visitor.observation}</TableCell>
                                        <TableCell className="flex flex-col gap-3">
                                            <SmartLink type={"internal"} route={"adminVisitorsIdUpdate"}
                                                params={[`${visitor.id}`]}>
                                                <Pen />
                                            </SmartLink>
                                            <SmartLink type={"internal"} route={"adminVisitorsIdDelete"}
                                                params={[`${visitor.id}`]}>
                                                <Trash />
                                            </SmartLink>
                                        </TableCell>
                                    </TableRow>

                                )}
                            </React.Fragment>
                        )))}
                    </tbody>

                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        {visitors.length === 0 ? (
                            <TableRow>
                                <TableCell className="text-center">
                                    Ainda não existem visitantes do site.
                                </TableCell>
                            </TableRow>
                        ) : (visitors.map((visitor) => (
                            <TableRow key={visitor.id}>
                                <TableHeader>Sequência</TableHeader>
                                <TableCell>{visitor.sequence}</TableCell>
                                <TableHeader>Nome</TableHeader>
                                <TableCell>{visitor.name}</TableCell>
                                <TableHeader>Email</TableHeader>
                                <TableCell>{visitor.email || 'Não informado'}</TableCell>
                                <TableHeader>Enviar notificações</TableHeader>
                                <TableCell className="flex items-center">
                                    {visitor.receiveNotifications
                                        ? <SquareCheck />
                                        : <SquareX />}
                                </TableCell>
                                <TableHeader>Data de entrada</TableHeader>
                                <TableCell>{new Date(visitor.createdAt).toLocaleDateString()}</TableCell>
                                <TableHeader>Observação</TableHeader>
                                <TableCell>{visitor.observation}</TableCell>
                                <TableCell className="flex flex-col gap-3">
                                    <SmartLink type={"internal"} route={"adminVisitorsIdUpdate"}
                                        params={[`${visitor.id}`]}>
                                        <Pen />
                                    </SmartLink>
                                    <SmartLink type={"internal"} route={"adminVisitorsIdDelete"}
                                        params={[`${visitor.id}`]}>
                                        <Trash />
                                    </SmartLink>
                                </TableCell>
                                <TableCell className="border-t-2 min-w-40 border-ochre_accent" />
                            </TableRow>
                        ))
                        )
                        }
                    </tbody>

                </Table>
            </div>

            <div>
                {visitorsData?.pagination &&
                    <Pagination
                        currentPage={visitorsData.pagination.page}
                        totalPages={Math.ceil(visitorsData.pagination.total / visitorsData.pagination.perPage)}
                        onPageChange={handlePageChange}
                    />
                }
            </div>
        </div>
    )
}